import config from '@/config'
import Ajax from '@/libs/ajax'

const ajax = new Ajax(config.serverConfig.serviceURL);

// 产品列表
const getProductList = ajax.post(config.apiConf.serviceApi + 'home/productList')

export default {
  getProductList
}
